"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var site_1 = require("./site");

exports.seoInterlinking = {
  BMAR: {
    minAvisosEnFacet: 5
  },
  ZJAR: {
    minAvisosEnFacet: 5
  },
  BMCL: {
    minAvisosEnFacet: 5
  },
  BMEC: {
    minAvisosEnFacet: 5
  },
  BMMX: {
    minAvisosEnFacet: 5
  },
  BMPA: {
    minAvisosEnFacet: 5
  },
  BMPE: {
    minAvisosEnFacet: 5
  },
  BMVE: {
    minAvisosEnFacet: 5
  }
};
exports.minAvisosEnFacetas = exports.seoInterlinking[site_1.siteId].minAvisosEnFacet;